"use strict";

Object.defineProperty(exports, "__esModule", {
  value: true
});
exports.ElevationsChart = ElevationsChart;
var _react = _interopRequireWildcard(require("react"));
var _styledComponents = require("styled-components");
var _hooks = require("../hooks");
var _utils = require("../utils");
function _interopRequireWildcard(e, t) { if ("function" == typeof WeakMap) var r = new WeakMap(), n = new WeakMap(); return (_interopRequireWildcard = function (e, t) { if (!t && e && e.__esModule) return e; var o, i, f = { __proto__: null, default: e }; if (null === e || "object" != typeof e && "function" != typeof e) return f; if (o = t ? n : r) { if (o.has(e)) return o.get(e); o.set(e, f); } for (const t in e) "default" !== t && {}.hasOwnProperty.call(e, t) && ((i = (o = Object.defineProperty) && Object.getOwnPropertyDescriptor(e, t)) && (i.get || i.set) ? o(f, t, i) : f[t] = e[t]); return f; })(e, t); }
const chartId = 'elevation-chart';
function ElevationsChart({
  Chart: _Chart,
  route,
  setChart,
  onHighlight
}) {
  const chartRef = (0, _react.useRef)(null);
  const {
    toDistance
  } = (0, _hooks.useUnits)();
  (0, _react.useEffect)(() => {
    async function init() {
      const {
        Chart,
        CategoryScale,
        Filler,
        LineController,
        LineElement,
        LinearScale,
        PointElement,
        Tooltip,
        Legend
      } = await Promise.resolve().then(() => _interopRequireWildcard(require('chart.js')));
      if (Chart) {
        Chart.register(LinearScale, CategoryScale, LineController, PointElement, LineElement, Tooltip, Legend, Filler);
        Chart.defaults.font.family = '"Roboto", "Helvetica", "Arial", sans-serif';
      }
    }
    if (!_Chart) init();
  }, []);
  (0, _react.useEffect)(() => {
    let _chart;
    async function update() {
      let Chart = _Chart;
      if (!Chart) ({
        Chart
      } = await Promise.resolve().then(() => _interopRequireWildcard(require('chart.js'))));
      if (Chart && route && chartRef.current) {
        let distance = 0;
        let elevationMin = Number.MAX_VALUE;
        let elevationMax = Number.MIN_VALUE;
        const data = route.sections.reduce((res, section, sectionIndex) => {
          if ('elevations' in section) {
            for (const {
              distanceFromStart: x,
              elevation: y,
              geometryIndex
            } of section.elevations) {
              elevationMin = Math.min(elevationMin, y);
              elevationMax = Math.max(elevationMax, y);
              res.push({
                x: x + distance,
                y,
                sectionIndex,
                geometryIndex
              });
            }
          } else {
            res.push({
              x: Number.NaN,
              y: Number.NaN
            });
          }
          distance += section.distance;
          return res;
        }, []);
        const offset = Math.round(Math.max(50 - (elevationMax - elevationMin), 0) / 2);
        _chart = new Chart(chartRef.current, {
          type: 'line',
          data: {
            datasets: [{
              data,
              borderColor: 'transparent',
              backgroundColor: '#3fb37f18',
              cubicInterpolationMode: 'monotone',
              pointRadius: 0,
              fill: {
                target: 'start'
              }
            }, {
              data,
              borderColor: 'transparent',
              pointBackgroundColor: 'transparent',
              cubicInterpolationMode: 'monotone',
              pointRadius: 1,
              segment: {
                borderColor: ctx => {
                  const d = ctx.p1.parsed.x - ctx.p0.parsed.x;
                  const h = ctx.p1.parsed.y - ctx.p0.parsed.y;
                  const slopePercentage = d ? 100 * h / d : 0;
                  return (0, _utils.getElevationColor)(slopePercentage);
                }
              }
            }]
          },
          options: {
            responsive: true,
            maintainAspectRatio: false,
            scales: {
              x: {
                type: 'linear',
                min: 0,
                max: route.distances.total,
                ticks: {
                  callback: value => toDistance(value)
                }
              },
              y: {
                type: 'linear',
                min: Math.floor(elevationMin - offset),
                max: Math.ceil(elevationMax + offset),
                offset: true,
                ticks: {
                  count: 4,
                  callback: value => `${typeof value === 'number' ? Math.round(value) : parseInt(value)} m`
                }
              }
            },
            interaction: {
              mode: 'index',
              intersect: false
            },
            plugins: {
              tooltip: {
                displayColors: false,
                callbacks: {
                  title: ([{
                    parsed: {
                      x
                    }
                  }]) => toDistance(x),
                  label: ({
                    parsed: {
                      y
                    }
                  }) => `${y} m`
                }
              },
              legend: {
                display: false
              }
            },
            onHover: (event, elements) => {
              if (elements[0]) {
                const {
                  sectionIndex,
                  geometryIndex
                } = data[elements[0].index];
                onHighlight?.(typeof sectionIndex === 'number' && typeof geometryIndex === 'number' ? {
                  sectionIndex,
                  geometryIndex
                } : null);
              } else {
                onHighlight?.(null);
              }
            }
          }
        });
        setChart?.(_chart);
      }
    }
    update();
    return () => {
      if (_chart) _chart.destroy();
    };
  }, [route, chartRef.current]);
  return /*#__PURE__*/_react.default.createElement(StyledChart, {
    id: chartId,
    onMouseLeave: () => onHighlight?.(null),
    ref: chartRef
  });
}
const StyledChart = _styledComponents.styled.canvas`
  height: 150px;
  width: 100%;
`;